<template>
    <div class="banner">
         <div class="banner-video">  
            <video src="@/assets/img/video/contact.mp4" loop="loop" autoplay="autoplay" x5-video-player-type="h5-page"  x5-video-player-fullscreen="" x5-video-orientation="portraint" class="footer-bg"></video>
        </div>
        <div class="container">
          <div class="banner-text">
                <h2>Contact<br>us</h2>
                <h3>联系我们</h3>
          </div>
        </div>
    </div>
</template>
<script>
  // Import Swiper styles
  export default {

};
</script>
<style scoped>
.banner{
  width: 100vw;
  height: 600px;
  z-index: -1;
  position: relative;
}
.banner-video video{
    width: 100%;
    height: 700px;
    margin-top: -100px;
    opacity: 0.9;
    object-fit: cover;
    position: absolute;
    z-index: -9999;
    left: 0px;
}
.container{
  position: relative;
}
.banner-text{
  position: absolute;
  color: #fff;
  left: 100px;
  top: 150px;
}
.banner-text h2{
  font-size: 60px;
  color: rgba(255,255,255,0.3);
  opacity: 0.1;
  text-align: left;
}
.banner-text h3{
  font-size: 36px;
  margin-top: -95px;
  border-top: 1px solid #eee3;
  text-align: left;
  line-height: 80px;
  letter-spacing: 10px;
}
</style>